import { isSddFinding } from './findingClassification';
import { groupByTitle } from './findingTarget';
import { normalizeFinding } from './severity';

const HIDDEN_OR_REMEDIATED_STATUSES = new Set([
  'suppressed',
  'possibly_remediated',
  'verified',
]);

const OPEN_STATUSES = new Set([
  'open',
  'reopened',
  'remediation_claimed',
]);

export function isVisibleSensitiveDataFinding(finding) {
  const normalized = normalizeFinding(finding);
  if (!normalized || !isSddFinding(normalized)) return false;
  return !HIDDEN_OR_REMEDIATED_STATUSES.has(normalized.status);
}

export function visibleSensitiveDataFindings(findings) {
  return (Array.isArray(findings) ? findings : [])
    .map(normalizeFinding)
    .filter(Boolean)
    .filter(isVisibleSensitiveDataFinding);
}

export function summarizeVisibleSensitiveData(findings) {
  const visibleFindings = visibleSensitiveDataFindings(findings);
  const groups = groupByTitle(visibleFindings);
  return {
    findings: visibleFindings,
    groups,
    findingCount: visibleFindings.length,
    groupCount: groups.length,
    openFindingCount: visibleFindings.filter(f => OPEN_STATUSES.has(f.status)).length,
    openGroupCount: groups.filter(g => g.findings.some(f => OPEN_STATUSES.has(f.status))).length,
  };
}
